import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'networks',
  initialState: {
    networkInfo: [],
    freeNetworks: [],
    networksList: [],
  },
  reducers: {
    onSetNetworks: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
  },
});

export default slice.reducer;

const { onSetNetworks } = slice.actions;
export const setNetworks = ({ field, value }) => async (dispatch) => {
  try {
    dispatch(onSetNetworks({ field, value }));
  } catch (e) {
    return console.error(e.message);
  }
};
